"use client"
import { Button } from "@workspace/web-ui/components/button"
  import { useEffect, useState } from "react"
import { AlfieChatBot } from "../../../components/alfie-chat"
import { useChatMutation } from "../../../api/mutations/chat"
import AlfieIcon from "~/components/icons/alfie-icon"
import { Input } from "@workspace/web-ui/components/input"
import { Search } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@workspace/web-ui/components/select"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { encountersQueryOptions,encounterQueryOptions ,chatHistoryQueryOptions,appointmentsQueryOptions,prescriptionsQueryOptions} from "./api/queries"
import { useSearch, useNavigate } from "@tanstack/react-router"
 import EmptyState from "./components/empty-state"
 import EncountersCard from "./components/encounters-card"
import EncountersDetails from "./components/encounters-details"
type SearchParams = {
  session_id?: string;
}
export default function EncountersPage() {
  const [showChatBot, setShowChatBot] = useState(false)
  const [search, setSearch] = useState("")
  const [type, setType] = useState("")
  const [date_filter, setDate] = useState("last_6_month")
  const navigate = useNavigate()
  const { session_id } = useSearch({ from: "/(dashboard)/dashboard/urgent-care/encounters/" }) as SearchParams
  const encountersQuery = useSuspenseQuery(encountersQueryOptions({
    disease_name: search,
    type,
    date_filter
  }));
  const [encounterId, setEncounterId] = useState(session_id ?? encountersQuery.data?.sessions[0]?.session_id)
  const { mutate: creatChatMutation } = useChatMutation();
const encounterQuery = useQuery(encounterQueryOptions(encounterId));
const chatHistoryQuery = useQuery(chatHistoryQueryOptions(encounterId));
const appointmentsQuery = useQuery(appointmentsQueryOptions(encounterId));
const prescriptionsQuery = useQuery(prescriptionsQueryOptions(encounterId));

  // Function to handle encounter selection
const handleEncounterSelect = (id:string) => {
  setEncounterId(id)
  navigate({
     search: { session_id: id } as any
  })
}

useEffect(() => {   
  if(session_id) {
    setEncounterId(session_id)
  }
}, [session_id])

useEffect(() => {   
  if(encounterId && encounterId !== session_id) {
    navigate({
       search: { session_id: encounterId } as any
    })
  }
}, [encounterId, session_id, navigate])

useEffect(() => {   
  console.log(encounterQuery.data?.session_overview)
  if(encounterId !== '' && encounterId !== undefined) {
    encounterQuery.refetch()
    chatHistoryQuery.refetch()
    appointmentsQuery.refetch()
    console.log('chatHistoryQuery',chatHistoryQuery.data)
    console.log('appointmentsQuery',appointmentsQuery.data)

  }
}, [encounterId])
console.log('chatHistoryQuery',chatHistoryQuery.data)

  useEffect(() => {
    if(search !== "" && search.length > 2) {
    encountersQuery.refetch()
    }
    if(type !== "last_6_month" && type !== "") {
    encountersQuery.refetch()

    }
    if(date_filter !== "last_6_month" && date_filter !== "") {
    encountersQuery.refetch()

    }
  }, [search, type, date_filter,encountersQuery])

   // Mock user data
  const user = {
    first_name: "Maurice",
    last_name: "Smith",
    avatar: "",
    health_profile: {
      weight: 185,
      target_weight: 165,
      timeframe: "3 months",
    },
  }

  const handleChatBotOpen = () => {
    creatChatMutation({
      message: "",
      thread_id: "",
    }, {
      onSuccess: (response) => {
            if (response.success) {
              // toast.success("Payment initiated");
              // window.location.replace(response.data?.payment_metadata.url || '');
              console.log("Chat initialized successfully", response.data?.triage_state.follow_up_question.content);
            //   setInitialChatMessage(response.data?.follow_up_question.content ?? "")
            //   setInitialThreadId(response.data?.thread_id ?? "")
            } else {
              // setErrorMessage(response.error || "An error occurred while initializing Chat");
              console.log()
            }
          },
          onError: () => {
            console.log("Failed to initialize chat")
            // setErrorMessage("Failed to initialize Chat");
          }
        })
    setShowChatBot(true)
  }
  const [selectedSessionId, setSelectedSessionId] = useState<string | null>(null);
  const resumeChatWithAlfie = (message:string,agent_id:string, thread_id: string,session_id:string) => {
    setSelectedSessionId(session_id);
    if (session_id === encounterId) {
    setShowChatBot(true);
    creatChatMutation({
      message: message,
      thread_id: thread_id,
      session_id: session_id,
      agent: agent_id,
    }, {
      onSuccess: (response) => {
            if (response.success) {
              // toast.success("Payment initiated");
              // window.location.replace(response.data?.payment_metadata.url || '');
              console.log("Chat resumed successfully", response.data?.triage_state.follow_up_question.content);
            //   setInitialChatMessage(response.data?.follow_up_question.content ?? "")
            //   setInitialThreadId(response.data?.thread_id ?? "")
            } else {
              // setErrorMessage(response.error || "An error occurred while initializing Chat");
              console.log()
            }
          },
          onError: () => {
            console.log("Failed to resume chat")
            // setErrorMessage("Failed to initialize Chat");
          }
        })
    setShowChatBot(true)
  }
}

const SortType =[
   { value: "closed", label: "Closed" },
  { value: "in_progress", label: "In Progress" },
  { value: "missed", label: "Missed" },
  { value: "red_flagged", label: "Red Flagged" },
  { value: "treatment_completed", label: "Treatment Completed" },
  { value: "completed", label: "Completed" }
]
const SortDate = [
   { value: "today", label: "Today" },
  { value: "this_week", label: "This week" },
  { value: "this_month", label: "This month" },
  { value: "this_year", label: "This Year" },
  { value: "last_3_month", label: "Last 3 Month" },
  { value: "last_6_month", label: "Last 6 Month" }


]
  return (
    <main className="flex w-full flex-col gap-6 h-screen overflow-y-scroll lg:overflow-hidden">
      <section className="pt-6 h-full ">
        {/* Greetings */}
        <span className="inline-flex gap-2 ">
          <h6 className="text-lg font-normal">Welcome,</h6>
          <h6 className="text-lg font-bold">{user?.first_name}</h6>
        </span>

        {/* Subnav one */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-2">
            <div>      
                <h1 className="lg:text-[40px] text-2xl font-bold lg:leading-[140%] tracking-[-2%]  text-[#1A202C]">Encounters</h1>
              <p className="text-[#464B55] text-[14px] lg:leading-[140%] tracking-[-1%] font-normal">View and manage your chat sessions and appointments</p>
              </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <Button variant="outline" style={{boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.1)"}}  className="border-[#DCDCDE] h-fit text-[#202020CC] !py-[12px] !px-[16px] rounded-[8px] flex items-center gap-2" onClick={handleChatBotOpen}>
             <AlfieIcon />   Start a treatment
            </Button>
          </div>
        </div>

        <div className="lg:flex hidden flex-col sm:flex-row justify-between items-start lg:gap-10 gap-4 sm:items-center mb-4">
            <div className="relative w-full lg:w-[40%]">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6C757D] size-5" />

            <Input type="text" placeholder="Search"   className=" py-[12px] !pl-[35px] px-[16px] h-auto rounded-[8px] w-full !outline-none border-[#DCDEE3] border-[1px]"
        name="search" id="search" value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <div className="flex flex-col sm:flex-row gap-3 lg:w-[35%] w-full">
            <Select value={type} onValueChange={(value) => setType(value)}>
                <SelectTrigger  className="py-[12px] bg-transparent px-[16px] h-auto rounded-[8px] w-full !outline-none border-[#DCDEE3] border-[1px]">
                    <SelectValue placeholder="Type: All" />
                </SelectTrigger>
                <SelectContent>
                  {SortType.map((type) => (
                    <SelectItem key={type.value} value={type.value}>
                      {type.label}
                    </SelectItem>
                  ))}
                </SelectContent>
            </Select>
            <Select value={date_filter} onValueChange={(value) => setDate(value)}  >
                <SelectTrigger  className="py-[12px]  bg-transparent px-[16px] h-auto rounded-[8px] w-full !outline-none border-[#DCDEE3] border-[1px]">
                    <SelectValue placeholder="Date: All time" />
                </SelectTrigger>
                <SelectContent>
                  {SortDate.map((date) => (
                    <SelectItem key={date.value} value={date.value}>
                      {date.label}
                    </SelectItem>
                  ))}
                </SelectContent>
            </Select>
          </div>
        </div>
        {/* Encounters list section */}
        <div className="w-full grid lg:grid-cols-2 grid-cols-1 gap-6">
            <div className="flex flex-col overflow-y-scroll h-[70vh] pb-40 gap-[16px] w-full">
              {encountersQuery.data?.sessions?.length && encountersQuery.data?.sessions?.length > 0 ? encountersQuery.data?.sessions?.map((session:any, index:number) => (
                    <EncountersCard key={index} session={session} handleEncounterSelect={handleEncounterSelect} />
                )) : <EmptyState title="No encounters available" message="Create a new encounter to get started" type="encounters" />}
        </div>
            <EncountersDetails resumeChatWithAlfie={resumeChatWithAlfie} isLoading={encounterQuery.isLoading} prescriptionsQuery={prescriptionsQuery} encounter={encounterQuery?.data?.session_overview} chatHistoryQuery={chatHistoryQuery} appointmentsQuery={appointmentsQuery}/>
       </div>

      </section>

      {/* Chatbot using Sheet component */}
      <AlfieChatBot  sessionId={selectedSessionId ?? undefined} open={showChatBot} onOpenChange={setShowChatBot} />

    </main>
  )

}